var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPaperPlane = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25.3664 0.129214L1.26322 9.1685C-0.0616528 9.66558 -0.430016 11.3657 0.570316 12.3667L7.22893 19.0253L17.2097 8.95966C17.741 8.42286 18.6071 8.42013 19.1432 8.95145C19.68 9.48345 19.6834 10.3489 19.1514 10.885L9.16318 20.9589L15.6349 27.4305C16.6359 28.4316 18.3353 28.0625 18.8324 26.7376L27.8717 2.63381C28.4584 1.06998 26.9309 -0.458936 25.3671 0.128529L25.3664 0.129214Z"
})));
export default SvgPaperPlane;